<template>
  <div id="product_input">
    <SegmentName>商品情報のご入力</SegmentName>
    <div class="table_block">
      <table>
        <tbody>
          <TableTr v-if="getHasRegistration === 'change'">
            <TableTh>申込日</TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="6" class="u-w--200">
                  <el-select
                    name="application_date_year"
                    placeholder=""
                    v-model="userForm.application_date_year"
                    @change="onChangeApplicationDate"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.ApplicationYears()"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
                <el-col :span="4" class="u-w--150">
                  <el-select
                    name="application_date_month"
                    placeholder=""
                    v-model="userForm.application_date_month"
                    @change="onChangeApplicationDate"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.Months"
                      :key="key"
                      :label="`${item.value}月`"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
                <el-col :span="4" class="u-w--150">
                  <el-select
                    name="application_date_day"
                    placeholder=""
                    v-model="userForm.application_date_day"
                    @change="onChangeApplicationDate"
                  >
                    <el-option
                      v-for="(item, key) in applicationDays"
                      :key="key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </td>
          </TableTr>

          <TableTr v-show="formProductInputFieldes.product.isShow">
            <TableTh>{{ formProductInputFieldes.product.label }}</TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap">
                <el-col :span="7">
                  <el-select
                    v-model="form.product"
                    :name="formProductInputFieldes.product.key"
                    @change="onChangeProduct()"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in getInstallmentProducts"
                      :key="index"
                      :value="item.id"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="7">
                  <el-input
                    v-model="form.product_other_name"
                    :disabled="!selectedProductName.includes('その他')"
                    :id="formProductInputFieldes.productOtherName.key"
                  ></el-input>
                </el-col>
              </el-row>
              <ErrorMessage class="error-product_other_name-required_if"></ErrorMessage>
              <ErrorMessage class="error-product_other_name-string"></ErrorMessage>
              <ErrorMessage class="error-product_other_name-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formProductInputFieldes.serviceStartDate.isShow && form.product">
            <TableTh>{{ formProductInputFieldes.serviceStartDate.label }}</TableTh>
            <td>
              <el-date-picker
                type="date"
                :clearable="true"
                :editable="false"
                :placeholder="formProductInputFieldes.serviceStartDate.label"
                format="yyyy年MM月dd日"
                v-model="form.service_start_date"
                :id="formProductInputFieldes.serviceStartDate.key"
                :disabled="!form.product"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <ErrorMessage class="error-service_start_date-date"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formProductInputFieldes.serviceEndDate.isShow && form.product">
            <TableTh>{{ formProductInputFieldes.serviceEndDate.label }}</TableTh>
            <td>
              <el-date-picker
                type="date"
                :clearable="true"
                :editable="false"
                :placeholder="formProductInputFieldes.serviceEndDate.label"
                format="yyyy年MM月dd日"
                v-model="form.service_end_date"
                :id="formProductInputFieldes.serviceEndDate.key"
                :disabled="!form.product"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <ErrorMessage class="error-service_end_date-date"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr>
            <TableTh>{{ formProductInputFieldes.cashTotal.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-input
                type="tel"
                v-model="form.cash_total"
                @blur="isComma('cash_total')"
                @focus="
                  zeroDelete('cash_total')
                  noneComma('cash_total')
                "
                @input="updateRemainigMoney('cash_total')"
                placeholder="金額"
                class="price_input"
                id="cash_total"
              >
                <span slot="suffix">円</span>
              </el-input>
              <ErrorMessage class="error-cash_total-required"></ErrorMessage>
              <ErrorMessage class="error-cash_total-integer"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr>
            <TableTh>{{ formProductInputFieldes.downPayment.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-input
                type="tel"
                v-model="form.down_payment"
                @blur="isComma('down_payment')"
                @focus="
                  zeroDelete('down_payment')
                  noneComma('down_payment')
                "
                @input="updateRemainigMoney('down_payment')"
                placeholder="金額"
                class="price_input"
                id="down_payment"
              >
                <span slot="suffix">円</span>
              </el-input>
              <!-- <ErrorMessage class="error-down_payment-required"></ErrorMessage> -->
              <ErrorMessage class="error-down_payment-integer"></ErrorMessage>
              <ErrorMessage class="error-down_payment-lt"></ErrorMessage>
            </td>
          </TableTr>
        </tbody>
      </table>
    </div>
    <SegmentName>お支払い方法のご入力</SegmentName>
    <div class="table_block">
      <table>
        <tbody>
          <TableTr>
            <TableTh>{{ formProductInputFieldes.remainingMoney.label }}</TableTh>
            <td>
              {{ form.remaining_money | isComma }} 円
              <ErrorMessage class="error-remaining_money-required" :validation="false"></ErrorMessage>
              <!-- 下記inputはバリデーション用 -->
              <input id="remaining_money" type="number" :value="form.remaining_money" class="d-none" />
            </td>
          </TableTr>
          <TableTr v-show="formProductInputFieldes.bonusFee.isShow">
            <TableTh>{{ formProductInputFieldes.bonusFee.label }}</TableTh>
            <td>
              <span id="bonus_total_fee">{{ form.split_fee | isComma }} </span> 円
              <span class="fz-12 text-danger"></span>
              <ErrorMessage class="error-split_fee-required_if" :validation="false"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formProductInputFieldes.splitFee.isShow">
            <TableTh>{{ formProductInputFieldes.splitFee.label }}</TableTh>
            <td>
              <span id="split_total_fee">{{ form.split_fee | isComma }} </span> 円
              <span class="fz-12 text-danger"></span>
              <ErrorMessage class="error-split_fee-required_if" :validation="false"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formProductInputFieldes.splitTotalPayment.isShow">
            <TableTh>{{ formProductInputFieldes.splitTotalPayment.label }}</TableTh>
            <td>
              <span id="split_total_pay">{{ form.split_total_payment | isComma }} </span> 円
              <span class="fz-12 text-danger"></span>
              <ErrorMessage class="error-split_total_payment-required_if" :validation="false"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr>
            <TableTh>{{ formProductInputFieldes.totalPay.label }}</TableTh>
            <td>
              <span id="total_pay">{{ form.total_pay | isComma }} </span> 円 <span class="fz-12 text-danger"></span>
              <ErrorMessage class="error-total_pay-required" :validation="false"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr>
            <TableTh>{{ formProductInputFieldes.payment.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-select
                id="finance_category_name"
                class="select--w250"
                v-model="form.finance_category_name"
                @change="onChangeFinanceCategoryName($event)"
                placeholder="金融カテゴリーを選択"
              >
                <el-option
                  v-for="(item, index) in getFinances"
                  :key="`finance_category_name_${index}`"
                  :value="item.category_name"
                  :label="item.category_name"
                ></el-option>
              </el-select>
              <el-select
                id="payment"
                class="select--w250"
                v-model="form.payment"
                @change="changePayment($event)"
                placeholder="お支払い方法を選択"
              >
                <template v-for="(item, index) in formProductInputFieldes.payment.choices">
                  <el-option
                    :key="`payment_${index}`"
                    :value="item.value"
                    :label="item.label"
                    v-if="item.isShow"
                  ></el-option>
                </template>
              </el-select>
              <ErrorMessage class="error-payment-required"></ErrorMessage>
              <ErrorMessage class="error-finance_category_name-required"></ErrorMessage>
              <ErrorMessage class="error-finance_category_name-string"></ErrorMessage>
              <ErrorMessage class="error-finance_category_name-exists"></ErrorMessage>
            </td>
          </TableTr>
        </tbody>
      </table>

      <table class="payment_form">
        <tbody>
          <TableTr>
            <td colspan="2" class="payment_style_title" v-show="form.payment">{{ PayTypeText[form.payment] }}</td>
          </TableTr>
          <!-- 分割回数 -->
          <TableTr v-show="formProductInputFieldes.splitNumber.isShow">
            <TableTh>{{ formProductInputFieldes.splitNumber.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-autocomplete
                name="split_number"
                popper-class="my-autocomplete"
                class="price_input"
                v-model="form.split_number"
                :fetch-suggestions="querySearchSplitNumber"
                placeholder="回数"
                @input="updateSplitNumber"
              >
                <span slot="suffix">回</span>
                <template slot-scope="{item}">
                  <div class="value">{{ item.label }}</div>
                </template>
              </el-autocomplete>
              <FormNotice class="mt-1">半角数字で入力してください。</FormNotice>
              <ErrorMessage class="error-split_number-required_if"></ErrorMessage>
              <ErrorMessage class="error-split_number-between"></ErrorMessage>
            </td>
          </TableTr>
          <!-- ボーナス併用加算額 -->
          <TableTr v-show="formProductInputFieldes.bonusCombinedAdditionAmount.isShow">
            <TableTh
              >{{ formProductInputFieldes.bonusCombinedAdditionAmount.label }}<span class="require">必須</span></TableTh
            >
            <td>
              <el-input
                type="tel"
                v-model="form.bonus_combined_addition_amount"
                @blur="isComma('bonus_combined_addition_amount')"
                @focus="
                  zeroDelete('bonus_combined_addition_amount')
                  noneComma('bonus_combined_addition_amount')
                "
                @input="simlation()"
                placeholder="金額"
                class="price_input"
                id="bonus_combined_addition_amount"
              >
                <span slot="suffix">円</span>
              </el-input>
              <ErrorMessage class="error-bonus_combined_addition_amount-required_if"></ErrorMessage>
            </td>
          </TableTr>
          <!-- 分割払い・ボーナス併用 -->
          <TableTr v-show="formProductInputFieldes.bonusCombinedMonth.isShow">
            <TableTh>{{ formProductInputFieldes.bonusCombinedMonth.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap">
                <el-col class="u-w--auto">{{
                  formProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth1.label
                }}</el-col>
                <el-col :span="5">
                  <el-select
                    class="select--w250"
                    v-model="form.bonus_combined_month1"
                    :placeholder="formProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth1.label"
                    @change="
                      simlation()
                      ignitionEvent('change', 'bonus_combined_month1')
                      ignitionEvent('change', 'bonus_combined_month2')
                    "
                    id="bonus_combined_month1"
                  >
                    <el-option
                      v-for="(item, index) in formProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth1.choices"
                      :key="`bonusCombinedMonth1_${index}`"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col class="u-w--auto">{{
                  formProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth2.label
                }}</el-col>
                <el-col :span="5">
                  <el-select
                    class="select--w250"
                    v-model="form.bonus_combined_month2"
                    :placeholder="formProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth2.label"
                    @change="
                      simlation()
                      ignitionEvent('change', 'bonus_combined_month2')
                      ignitionEvent('change', 'bonus_combined_month1')
                    "
                    id="bonus_combined_month2"
                  >
                    <el-option
                      v-for="(item, index) in formProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth2.choices"
                      :key="`bonusCombinedMonth1_${index}`"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <ErrorMessage class="error-bonus_combined_month-required_if"></ErrorMessage>
            </td>
          </TableTr>
          <!-- ボーナス1回払い・ボーナス2回払い -->
          <TableTr v-show="formProductInputFieldes.bonusCombinedNumber.isShow">
            <TableTh>{{ formProductInputFieldes.bonusCombinedNumber.label }}</TableTh>
            <td>
              <span id="split_first_pay">{{ form.bonus_combined_number }} </span> 回
              <input type="text" id="bonus_combined_payment" class="d-none" />
              <ErrorMessage class="error-bonus_combined_addition_amount-unit"></ErrorMessage>
              <ErrorMessage class="error-bonus_combined_payment-percent"></ErrorMessage>
              <ErrorMessage class="error-bonus_combined_number-required_if" :validation="false"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formProductInputFieldes.bonusOnceMonth.isShow">
            <TableTh>{{ formProductInputFieldes.bonusOnceMonth.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-select
                class="select--w250"
                v-model="form.bonus_once_month"
                :placeholder="formProductInputFieldes.bonusOnceMonth.label"
                @change="
                  updateBonusSecondMonth()
                  ignitionEvent('change', 'bonus_once_month')
                "
                name="bonus_once_month"
              >
                <el-option
                  v-for="(item, index) in getBonusOnceMonthChoices"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
              <el-button @click="fixBonusMonth = !fixBonusMonth" :disabled="isfixBonusMonthFieldDisable()"
                >修正</el-button
              >
              <ErrorMessage class="error-bonus_once_month-required_if"></ErrorMessage>
              <ErrorMessage class="error-bonus_once_month-date"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formProductInputFieldes.bonusTwiceMonth.isShow">
            <TableTh>{{ formProductInputFieldes.bonusTwiceMonth.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-select
                class="select--w250"
                v-model="form.bonus_twice_month"
                :placeholder="formProductInputFieldes.bonusTwiceMonth.label"
                @change="
                  updatePaymentPeriodStart()
                  ignitionEvent('change', 'bonus_twice_month')
                "
                id="bonus_twice_month"
              >
                <el-option
                  v-for="(item, index) in getBonusTwiceMonthChoices"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>

              <!-- <el-input-number
                                v-model="form.bonus_twice_month"
                                @change="updatePaymentPeriodStart();ignitionEvent('change','bonus_twice_month');"
                                :min="1"
                                :max="12"
                                v-if="fixBonusMonth"
                            ></el-input-number> -->

              <el-button @click="fixBonusMonth = !fixBonusMonth" :disabled="isfixBonusMonthFieldDisable()"
                >修正</el-button
              >
              <ErrorMessage class="error-bonus_twice_month-required_if"></ErrorMessage>
              <ErrorMessage class="error-bonus_twice_month-date"></ErrorMessage>
            </td>
          </TableTr>
          <!-- 支払期間 開始 -->
          <TableTr>
            <TableTh>{{ formProductInputFieldes.paymentPeriodStart.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-select
                :placeholder="formProductInputFieldes.paymentPeriodStartY.label"
                class="select--w120"
                v-model="formExtends.payment_period_start_y"
                @change="generatePaymentPeriodStart()"
                :disabled="isPaymentPeriodStartYDisable"
              >
                <el-option
                  v-for="(item, index) in getPaymentPeriodStartYearList()"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
              年
              <el-select
                :placeholder="formProductInputFieldes.paymentPeriodStartM.label"
                class="select--w90"
                v-model="formExtends.payment_period_start_m"
                @change="generatePaymentPeriodStart()"
                :disabled="isPaymentPeriodStartMDisable"
              >
                <el-option
                  v-for="(item, index) in formProductInputFieldes.paymentPeriodStartM.choices"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                  :disabled="isPaymentPeriodStartMonthDisable(item)"
                ></el-option>
              </el-select>
              月
              <el-input type="hidden" v-model="form.payment_period_start" id="payment_period_start"></el-input>
              <!--
                            <el-date-picker type="date" :clearable="false" :editable="false"
                                :placeholder="formProductInputFieldes.paymentPeriodStart.label" format="yyyy年MM月" v-model="form.payment_period_start"
                                @change="updatePaymentPeriodEnd();ignitionEvent('change','payment_period_start');" :picker-options="getPickerOptions" id="payment_period_start"
                                value-format="yyyy-MM-dd"
                            ></el-date-picker>
 -->
              <ErrorMessage class="error-payment_period_start-required"></ErrorMessage>
              <ErrorMessage class="error-payment_period_start-date"></ErrorMessage>
            </td>
          </TableTr>
          <!-- 支払期間 終了 -->
          <TableTr>
            <TableTh>{{ formProductInputFieldes.paymentPeriodEnd.label }}</TableTh>
            <td>
              <span id="split_first_pay_date">{{ form.payment_period_end | dateFormat('YYYY年MM月') }} </span>
              <ErrorMessage class="error-payment_period_end-required" :validation="false"></ErrorMessage>
              <ErrorMessage class="error-payment_period_end-date" :validation="false"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr>
            <TableTh>{{ formProductInputFieldes.paymentAmountOnce.label }}</TableTh>
            <td>
              <el-input
                type="tel"
                v-show="form.payment === 'seconds' && fixSecondPayment"
                v-model="form.payment_amount_once"
                @blur="() => {
                  isComma('payment_amount_once')
                  validatePaymentAmountSecond()
                }"
                @focus="
                  zeroDelete('payment_amount_once')
                  noneComma('payment_amount_once')
                "
                @input="changeSecondPayment"
                placeholder="金額"
                class="price_input price_input__left"
                id="payment_amount_once"
              >
                <span slot="suffix">円</span>
              </el-input>
              <template v-if="!fixSecondPayment">
                <span id="split_second_pay">{{ form.payment_amount_once | isComma }} </span> 円
              </template>
              <el-button v-if="form.payment === 'seconds' && !fixSecondPayment" @click="editSecondPayment"
                >修正</el-button
              >
              <ErrorMessage class="error-payment_amount_once-calc_remainder" :validation="false"></ErrorMessage>
              <ErrorMessage class="error-payment_amount_once-limit"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formProductInputFieldes.paymentAmountSecond.isShow">
            <TableTh>{{ formProductInputFieldes.paymentAmountSecond.label }}</TableTh>
            <td>
              <span id="split_second_pay">{{ form.payment_amount_second | isComma }} </span> 円
              <el-input
                type="hidden"
                v-model="form.payment_amount_second"
                placeholder="金額"
                class="price_input"
                id="payment_amount_second"
              >
              </el-input>
              <ErrorMessage class="error-payment_amount_second-required_if" :validation="false"></ErrorMessage>
              <ErrorMessage class="error-payment_amount_second-limit"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr>
            <TableTh>{{ formProductInputFieldes.personCharge.label }}<span class="require">必須</span></TableTh>
            <td>
              <el-input
                v-model="form.person_charge"
                :placeholder="formProductInputFieldes.personCharge.label"
                id="person_charge"
              >
              </el-input>
              <ErrorMessage class="error-person_charge-required"></ErrorMessage>
              <ErrorMessage class="error-person_charge-maxlen"></ErrorMessage>
            </td>
          </TableTr>
        </tbody>
      </table>
    </div>
    <div class="btn_wrap">
      <el-button type="primary" icon="el-icon-arrow-right" @click="nextPage">次へ進む</el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {splitPay, splitBonusPay, oncePay, secondsPay, monthlyPay} from '@/js/util/simlator'
import {validate, setErrorLaravel, removeError} from '@/js/util/validate/validateFunction'
import {
  ValidationRulesFun,
  ValidationRulesCommon,
  ValidationRulesCredit,
  ValidationRulesInstallment
} from '@/js/util/member/formProductInputValidationRules'
import * as FormUserInputOptionConstants from '@/js/util/member/formUserInputOptionConstants'
import {Conversions, peymentPeriodYears} from '@/js/util/member/formProductInputOptionConstants'
import * as helper from '@/js/util/helper'
// import mixins from '@/js/mixins/productInput'
import {mapGetters, mapActions} from 'vuex'
import {PayTypeText} from '@/js/util/constants'
import {
  ADD_MONTH_AFTER_NEXT,
  PAYMENT_START_BORDER_DAY,
  startPeriodAddMonth,
  useNewPaymentStartRule as readUseNewPaymentStartRule
} from '@/js/util/paymentStartPeriod'
import {FormProductInputFieldes} from '@/js/util/member/formProductInputFieldes'
import ErrorMessage from '@/js/components/member/common/Atoms/ErrorMessage'
import SegmentName from '@/js/components/member/common/Atoms/SegmentName'
import TableTh from '@/js/components/member/common/Molecules/TableTh'
import TableTr from '@/js/components/member/common/Molecules/TableTr'
import FormNotice from '@/js/components/member/common/Atoms/FormNotice'

export default {
  // mixins: [mixins],
  data() {
    return {
      formProductInputFieldes: {},
      form: {},
      formExtends: {},
      userForm: {},
      // validations: ValidationRules,
      product: 0,
      fixBonusMonth: false, // 自社割賦のみボーナス月を自由に修正できるフラグ
      splitNumberInput: false, // 分割回数を手入力でも入力できるフラグ
      fixSecondPayment: false, // ボーナス２回払いのタイミングで金額調整が可能かどうかのフラグ
      finishTime: '',
      first_pay_months_state: false,
      option: '',
      PayTypeText: PayTypeText,
      paymentPeriodStartYearList: [],
      isPaymentPeriodStartYDisable: false,
      isPaymentPeriodStartMDisable: false,
      productOptions: {},
      formUserInputOptionConstants: FormUserInputOptionConstants,
      applicationDays: [],
      storeFinanceId: null    // 金融商品情報ID(store_finances.id)
    }
  },
  components: {
    ErrorMessage,
    SegmentName,
    TableTh,
    TableTr,
    FormNotice
  },
  async created() {
    this.formProductInputFieldes = FormProductInputFieldes(
      this.getHasPayment,
      this.form,
      this.getAppDate,
      this.getFinances,
      this.getOption
    )
  },
  async mounted() {
    const getOptionForce = () => {
      return new Promise((resolve) => {
        const intervalId = setInterval(() => {
          const option = JSON.parse(JSON.stringify(this.getOption))
          if (option.id) {
            clearInterval(intervalId)
            resolve(option)
          }
        }, 500)
      })
    }
    this.productOptions = await getOptionForce()

    // バリデーションを定義
    validate(this.returnValidationRules(), true, this.getHasPayment)

    this.$emit('page', 'form-product-input')
    window.scrollTo(0, 0)

    this.productOption()

    //storeのformの情報を入れる
    const form_list = _.cloneDeep(this.getForm)
    form_list.finance_category_name = this.getFinances.find(x => x.is_initial).category_name  // 「通常」が管理画面から文言変更できるようになったため
    this.form = this.valueConversion(Conversions, true, form_list)
    this.splitPaymentPeriodStartYM()

    this.userForm = _.cloneDeep(this.getUserInputForm)
    this.onChangeApplicationDate()

    // 信販の場合 デフォルトの商品を追加する
    if (this.getHasPayment === 'credit') {
      const product = this.getCreditProducts[0] ?? null
      this.form.product = product ? product.id : null
    }

    // 支払い方法が入力済の場合
    if (this.form.payment) {
      // 選択肢に無い場合paymentをnullにする
      const existChoice = this.formProductInputFieldes.payment.choices.some(
        (choice) => choice.value === this.form.payment
      )
      if (!existChoice) this.form.payment = null
    }

    // Laravelのバリデーションエラーメッセージ
    if (this.getValidations.length) {
      this.getValidations.map((validate) => {
        setErrorLaravel(validate.key, validate.rule, validate.message, true)
      })
    }
  },
  beforeDestroy() {
    // バリデーションを削除
    validate(this.returnValidationRules(), false, this.getHasPayment)
  },
  computed: {
    // 申込日を定義
    getAppDate() {
      return this.form.created_at ? moment(this.form.created_at).startOf('day') : moment().startOf('day')
    },
    /**
     * 加盟店の支払開始月ルール(true: 新 = 翌月基準 / false: 現行 = 翌々月基準)
     *
     * 申込画面はまだ契約が存在しないため加盟店の現在設定を参照する。
     * この値は契約登録時に contracts へ焼き込まれ、以降の修正画面はそちらを参照する。
     */
    useNewPaymentStartRule() {
      return readUseNewPaymentStartRule(this.option)
    },
    // 支払開始日のdatepickerのオプション
    getPickerOptions() {
      const self = this
      const options = {
        disabledDate(date) {
          return self.getAppDate.isAfter(date, 'day')
        }
      }
      return options
    },
    /**
     * 支払月1回目の選択肢
     */
    getBonusOnceMonthChoices() {
      if (this.formProductInputFieldes.bonusOnceMonth) {
        if (this.fixBonusMonth) {
          return this.formProductInputFieldes.bonusOnceMonth.fixChoices
        } else {
          return this.formProductInputFieldes.bonusOnceMonth.choices
        }
      } else {
        return []
      }
    },
    /**
     * ボーナス二回の第2回目支払月の選択肢
     */
    getBonusTwiceMonthChoices() {
      if (this.formProductInputFieldes.bonusTwiceMonth) {
        if (this.fixBonusMonth) {
          return this.formProductInputFieldes.bonusTwiceMonth.fixChoices
        } else {
          return this.formProductInputFieldes.bonusTwiceMonth.choices
        }
      } else {
        return []
      }
    },
    /**
     * シュミレーションで使用するアドオン率を取得
     */
    getAddon() {
      if (this.getFinances.length) {
        const result = this.getFinances.filter((fin) => fin.category_name === this.form.finance_category_name)
        return result.length ? result[0] : null
      } else {
        return null
      }
    },
    /**
     * 選択中の商品名を取得
     */
    selectedProductName() {
      const filter = this.getInstallmentProducts.filter((product) => product.id === this.form.product)
      if (!filter.length) return ''

      return filter[0].name
    },
    ...mapGetters({
      getHasPayment: 'status/getHasPayment',
      getHasRegistration: 'status/getHasRegistration',
      getUserInputForm: 'userInput/getForm',
      getForm: 'productInput/getForm',
      getFinances: 'productInput/getFinances',
      getOption: 'productInput/getOption',
      getAllOptions: 'productInput/getAllOptions',
      getInstallmentProducts: 'productInput/getInstallmentProducts',
      getCreditProducts: 'productInput/getCreditProducts',
      getValidations: 'productInput/getValidations'
    })
  },
  watch: {
    fixBonusMonth: function (newVal, oldVal) {
      this.udpateBonusOnceMonth()
    },
    form: {
      async handler(newValue) {
        this.formProductInputFieldes = FormProductInputFieldes(
          this.getHasPayment,
          newValue,
          this.getAppDate,
          this.getFinances,
          this.option
        )
      },
      deep: true
    },
    option: function (newValue) {
      this.formProductInputFieldes = FormProductInputFieldes(
        this.getHasPayment,
        this.form,
        this.getAppDate,
        this.getFinances,
        newValue
      )
    },
    getFinances: function (newValue) {
      this.formProductInputFieldes = FormProductInputFieldes(
        this.getHasPayment,
        this.form,
        this.getAppDate,
        newValue,
        this.option
      )
      this.setStoreFinanceId(this.getFinances.find(x => x.is_initial).category_name)
    },
    getOption: function (newValue) {
      newValue = newValue.find(x => x.has_payment === this.getHasPayment)
      this.formProductInputFieldes = FormProductInputFieldes(
        this.getHasPayment,
        this.form,
        this.getAppDate,
        this.getFinances,
        newValue
      )
    }
  },
  methods: {
    setStoreFinanceId(financeCategoryName) {
      this.storeFinanceId = this.getFinances.find(fin => fin.category_name === financeCategoryName)?.id
      if(!this.storeFinanceId) {
        console.error('金融商品情報IDが取得できませんでした。')
      }
    },
    /**
     * バリデーションのルールをレスポンス
     */
    returnValidationRules() {
      const uniqueRule = this.getHasPayment === 'credit' ? ValidationRulesCredit : ValidationRulesInstallment
      
      if(ValidationRulesCommon.split_number.some(x => x.key === 'split_number_between')) {
        const betweenRule = ValidationRulesCommon.split_number.find(x => x.key === 'split_number_between')
        betweenRule.rule = `between:${this.productOptions.split_lower_limit},${this.productOptions.split_limit},回`
      } else {
        ValidationRulesCommon.split_number.push({
          rule: `between:${this.productOptions.split_lower_limit},${this.productOptions.split_limit},回`,
          event: 'blur,change'
        })
      }
      return ValidationRulesFun(ValidationRulesCommon, uniqueRule)
    },
    /**
     * 支払い金額のバリデーション
     */
    validatePaymentAmountSecond() {
      if(this.form.payment === 'seconds') {
        const reqErrorEl = document.querySelector('.error-payment_amount_second-limit')
        reqErrorEl.innerHTML = ''
        const header = reqErrorEl.closest('.js_error').querySelector('.js_error_header')
        header.classList.remove(`is_active_payment_amount_second_limit`)
        if(this.form.payment_amount_second < 1) {
          reqErrorEl.innerHTML = '支払金額の2回目以降は必ず0円以上の金額が必要です。'
          header.classList.add(`is_active_payment_amount_second_limit`)
        }
      }
    },
    /**
     * 申込フローの次ページに遷移するときの処理
     */
    nextPage() {
      // 頭金未入力の場合0を挿入する
      if (!this.form.down_payment) {
        this.form.down_payment = '0'
      }

      const validationRules = this.returnValidationRules()
      for (let key in validationRules) {
        validationRules[key].map((validation) => {
          this.ignitionEvent(validation.event, key)
        })
      }

      // 支払い回数2回目のバリデーション実行
      this.validatePaymentAmountSecond()
      
      setTimeout(() => {
        const errors = document.querySelectorAll('.js_error_message')
        let error_class = ''
        for (var i = 0; i < errors.length; i++) {
          if (errors[i].innerHTML) {
            error_class = errors[i].className
            break
          }
        }
        if (error_class) {
          helper.helperSmoothScroll(error_class)
        } else {
          this.setForm(this.valueConversion(Conversions, false, this.form))
          this.setUserForm(this.userForm)
          this.updateValidationsProductInput([])
          this.$emit('next')
        }
      }, 100)
    },
    /**
     * ボ２回払いの金額修正
     */
    editSecondPayment() {
      this.fixSecondPayment = true
    },

    /**
     * ボ２回払いの金額修正時の自動計算
     */
    changeSecondPayment() {
      if (!this.form.cash_total || !this.form.down_payment) {
        return
      }
      this.form.payment_amount_second =
        helper.helperNoneComma(this.form.split_total_payment) - helper.helperNoneComma(this.form.payment_amount_once)
    },

    /**
     * 支払い開始日（年）の日付を取得
     */
    getPaymentPeriodStartYearList() {
      return peymentPeriodYears(this.getAppDate.year())
    },

    /**
     * 支払い開始日（月）disabled制御
     * ※ドロップダウンリストのoptionタグごとにdisabledを制御する関数
     */
    isPaymentPeriodStartMonthDisable(item) {
      // formExtends.payment_period_start_y : 支払期間 開始の入力値
      let y = this.formExtends.payment_period_start_y ? this.formExtends.payment_period_start_y : this.getAppDate.year()
      let m = item.value
      let d = 27 // 日付は関係無い
      let targetMoment = moment(`${y}-${m}-${d}`) // 比較する日付

      // ❶支払方法 分割払い or 分割またはボーナス併用 + 翌月可能なフラグが設定されている
      // ❷支払方法 マンスリークリア + 翌月可能なフラグが設定されている
      const isBorderRuleEnabled =
        (this.form.payment === 'split' && this.option.setting_split_bonus_start_period) ||
        (this.form.payment === 'split_bonus' && this.option.setting_split_bonus_start_period) ||
        (this.form.payment === 'monthly' && this.option.setting_monthly_start_period)

      // 選択できる最短の月(申込月からの加算月)
      const minAddMonth = startPeriodAddMonth(this.getAppDate, isBorderRuleEnabled, this.useNewPaymentStartRule)
      // 上記フラグONかつ区切り日以内の場合のみ【翌月・翌々月】の2択(8月申込の場合は9月と10月選択可)。
      // それ以外(フラグONで区切り日超過 = 翌々月固定 / フラグOFF = 現行なら翌々月固定・新なら翌月固定)は1ヶ月固定
      const maxAddMonth =
        isBorderRuleEnabled && this.getAppDate.date() <= PAYMENT_START_BORDER_DAY ? ADD_MONTH_AFTER_NEXT : minAddMonth

      // isAfter は「より後」の判定のため下限は1ヶ月手前に置く
      const startMomment = moment(this.getAppDate).add(minAddMonth - 1, 'month')
      const limitMoment = moment(this.getAppDate).add(maxAddMonth, 'month') // 制限日付

      return !(targetMoment.isAfter(startMomment, 'month') && targetMoment.isSameOrBefore(limitMoment, 'month'))
    },

    /**
     * 支払い開始日項目 disabled制御
     */
    isPaymentPeriodStartFieldDisable() {
      // 支払い方法 分割またはボーナス併用、マンスリークリア以外はdisable
      // const passedPayments = ['split', 'split_bonus', 'monthly']
      // if (!passedPayments.includes(this.form.payment)) return true

      // // 支払い方法 分割払い or 分割またはボーナス併用の場合
      // if(this.form.payment === 'split' || this.form.payment === 'split_bonus') {
      //   return true
      // }
      // // 支払い方法 マンスリークリアの場合
      // if(this.form.payment === 'monthly') {
      //   if(yearflg) return true
      //   return !this.option.setting_monthly_start_period
      // }

      // 加盟店ごとに契約設定を可能とする改修要望により結果的に全てdisabledの運用となったため。
      return true
    },

    /**
     * ボーナス1括 ボーナス2括 disabled制御
     */
    isfixBonusMonthFieldDisable() {
      return !this.option.setting_bonus_fixed_month
    },

    /**
     * 支払い開始日の日付を更新して終了日を計算
     */
    generatePaymentPeriodStart() {
      const momentDate = moment()
      const month = this.formExtends.payment_period_start_m ? this.formExtends.payment_period_start_m : this.getAppDate.month()
      let year = this.formExtends.payment_period_start_y ? this.formExtends.payment_period_start_y : this.getAppDate.year()
      // 年跨ぎが発生する場合(2023年12月と2024年1月で表示される場合)  ※分割払いの場合、支払い開始月も固定になり不要となったため
      // if(
      //   this.getAppDate.month() === 10 && d <= 10 &&  // 申込月が11月で日にちが10日以前
      //   (this.form.payment === 'split' && this.option.setting_split_bonus_start_period) ||
      //   (this.form.payment === 'split_bonus' && this.option.setting_split_bonus_start_period) ||
      //   (this.form.payment === 'monthly' && this.option.setting_monthly_start_period)
      // ) {
      //   if(this.getAppDate.year() !== year && month === 12) this.formExtends.payment_period_start_y -= 1
      //   if(this.getAppDate.year() === year && month === 1) this.formExtends.payment_period_start_y += 1
      // }
      momentDate.year(
        year
      )
      momentDate.month(
        month - 1
      )
      momentDate.date(27)
      this.form.payment_period_start = helper.helperGetBusinessDay(momentDate).format('YYYY-MM-DD')
      this.updatePaymentPeriodEnd()
    },
    splitPaymentPeriodStartYM() {
      if (!this.form.payment_period_start) {
        this.formExtends.payment_period_start_y = ''
        this.formExtends.payment_period_start_m = ''
      } else {
        const ymd = moment(this.form.payment_period_start)
        this.formExtends.payment_period_start_y = ymd.year()
        this.formExtends.payment_period_start_m = ymd.month() + 1
      }
    },
    /**
     * 商品の値変更処理
     */
    onChangeProduct() {
      const filter = this.getInstallmentProducts.filter((product) => product.id === this.form.product)
      if (!filter.length) {
        this.form.service_start_date = null
        this.form.service_end_date = null
        return
      }
      if (filter[0].name !== 'その他') this.form.product_other_name = ''
    },
    /**
     * 金融カテゴリーが変更があった場合
     */
    onChangeFinanceCategoryName() {
      const initNull = [
        'payment',
        'split_number',
        'bonus_combined_addition_amount',
        'bonus_combined_month1',
        'bonus_combined_month2',
        'bonus_combined_number',
        'bonus_once_month',
        'bonus_twice_month',
        'payment_amount_once',
        'payment_amount_second',
        'split_fee',
        'split_total_payment',
        'total_pay',
        // 'person_charge',         // 担当者 フルネーム
        'payment_period_start',
        'payment_period_end'
      ]
      // 初期化値がnull
      initNull.map((item) => {
        this.form[item] = null
      })

      // オプション項目の再設定
      this.setStoreFinanceId(this.form.finance_category_name)
      this.option = this.getAllOptions.find(option => option.has_payment === this.getHasPayment && option.store_finance_id === this.storeFinanceId)
      this.productOptions = {...this.option}

      // 分割回数のbetweenバリデーションが変動するため再更新
      validate(this.returnValidationRules(), true, this.getHasPayment)

      removeError('finance_category_name', 'exists')
    },
    /**
     * 支払方法項目より下の項目の値を初期化する処理
     * @param {object} e
     */
    changePayment(e) {
      const initNull = [
        'split_number',
        'bonus_combined_addition_amount',
        'bonus_combined_month1',
        'bonus_combined_month2',
        'bonus_combined_number',
        'bonus_once_month',
        'bonus_twice_month',
        'payment_amount_once',
        'payment_amount_second',
        'split_fee',
        'split_total_payment',
        'total_pay',
        // 'person_charge',         // 担当者 フルネーム
        'payment_period_start',
        'payment_period_end'
      ]
      // const initKuhaku = [
      //     'payment_period_start',
      //     'payment_period_end',
      // ]
      // 初期化値がnull
      initNull.map((item) => {
        this.form[item] = null
      })
      // 初期化値が空白
      // initKuhaku.map(item => {
      //     this.form[item] = '';
      // });

      // バリデーション用のボーナス加算回数を初期化
      document.getElementById('bonus_combined_payment').value = null

      this.isPaymentPeriodStartYDisable = this.isPaymentPeriodStartFieldDisable()   // 年
      this.isPaymentPeriodStartMDisable = this.isPaymentPeriodStartFieldDisable()  // 月

      // change eventを強制発火
      this.ignitionEvent('change', 'payment')

      // 支払方法によって処理を変更
      switch (this.form.payment) {
        case 'once':
          this.fixSecondPayment = false
          // 支払月1回目の更新へ
          setTimeout(() => {
            this.udpateBonusOnceMonth()
          }, 10)
          break
        case 'seconds':
          // 支払月1回目の更新へ
          setTimeout(() => {
            this.udpateBonusOnceMonth()
          }, 10)
          break
        default:
          this.fixSecondPayment = false
          // 支払期間 開始の更新へ
          this.updatePaymentPeriodStart()
          break
      }
    },
    zeroDelete(form) {
      //金額欄0なら削除
      if (this.form[form]) {
        if (this.form[form] == 0) {
          this.form[form] = ''
        }
      }
    },
    /**
     * 現在価格合計と頭金が変更したときの処理
     * @param {string} type 項目タイプ
     */
    updateRemainigMoney(type) {
      // 頭金
      const down_payment = Number(String(this.form.down_payment).replace(/,/g, '')) | 0
      // 現在価格合計
      const cash_total = Number(String(this.form.cash_total).replace(/,/g, '')) | 0
      // 残金を計算
      this.form.remaining_money = cash_total - down_payment
      // this.isComma('remaining_money');
      this.ignitionEvent('blur', 'remaining_money')
      if (type === 'cash_total') {
        this.ignitionEvent('input', 'down_payment')
      }

      if (this.form.payment) this.simlation()
    },
    productOption() {
      //加盟店のアドオンなどを取得する処理
      if (this.getOption) {
        this.option = this.getOption
        if (this.form.payment) this.simlation()
      } else {
        setTimeout(() => {
          this.productOption()
        }, 1000)
      }
    },
    /**
     * 分割回数検索
     */
    querySearchSplitNumber(queryString, cb) {
      var select = this.formProductInputFieldes.splitNumber.choices
      var results = queryString ? select.filter(this.createFilterSplitNumber(queryString)) : select
      cb(results)
    },
    createFilterSplitNumber(queryString) {
      return (item) => {
        return item.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },

    /**
     * 分割回数・手入力時の値更新
     */
    updateSplitNumber(value) {
      if (value == null || value == '') {
        this.form.split_number = null
        return
      }
      if (!value.match(/^[0-9]+$/) || value.length > 3) {
        this.form.split_number = null
        return
      }
      this.form.split_number = value
      this.updatePaymentPeriodStart()
      this.ignitionEvent('change', 'split_number')
    },
    // 支払月1回目更新
    udpateBonusOnceMonth() {
      // 支払月1回目が変更になったときに支払月2回目の値がselectの値と同じのがなければ初期化される。
      if (this.getBonusOnceMonthChoices.length) {
        this.form.bonus_once_month = this.getBonusOnceMonthChoices[0].value

        // change event強制発火
        this.ignitionEvent('change', 'bonus_once_month')
      }

      // 支払月2回目の更新へ
      this.updateBonusSecondMonth()
    },
    // 支払月2回目更新
    updateBonusSecondMonth() {
      // 支払期間 開始の更新へ
      setTimeout(async () => {
        if (this.form.payment === 'seconds' && this.getBonusTwiceMonthChoices.length) {
          this.form.bonus_twice_month = this.getBonusTwiceMonthChoices[0].value

          // change event強制発火
          await this.ignitionEvent('change', 'bonus_twice_month')
          // const same = this.formProductInputFieldes.bonusTwiceMonth.choices.filter(month => month.value === this.form.bonus_twice_month);
          // if(!same.length) {
          // }
        }
        await this.updatePaymentPeriodStart()
      }, 10)
    },
    // 支払期間 開始更新
    updatePaymentPeriodStart() {
      // 支払い方法 分割払い、分割またはボーナス併用、マンスリークリアの場合
      const isBorderRuleEnabled =
        (this.form.payment === 'split' && this.option.setting_split_bonus_start_period) ||
        (this.form.payment === 'split_bonus' && this.option.setting_split_bonus_start_period) ||
        (this.form.payment === 'monthly' && this.option.setting_monthly_start_period)

      // 支払開始月の月定義
      // フラグON : 区切り日(10日)以内なら翌月、超過なら翌々月
      // フラグOFF: 現行ルールなら翌々月固定、新ルールなら翌月固定
      const add_month = startPeriodAddMonth(this.getAppDate, isBorderRuleEnabled, this.useNewPaymentStartRule)

      // 引き落とし日
      const hikiotoshi_day = 27

      // 基準日
      const start =
        this.form.payment === 'monthly'
          // startOf('day')：本日の開始時間(00:00:00)を指す
          ? moment().date(hikiotoshi_day).add(add_month, 'M').startOf('day').format('YYYY-MM-DD')
          : this.form.payment === 'once' || this.form.payment === 'seconds'   // ボーナス一括・ボーナス2回払い
          ? this.form.bonus_once_month                                        // 支払月1回目
            ? moment(this.form.bonus_once_month).date(hikiotoshi_day).startOf('day').format('YYYY-MM-DD')
            : null
          : moment().date(hikiotoshi_day).add(add_month, 'M').startOf('day').format('YYYY-MM-DD')
          
      // if(this.form.payment === 'once' || this.form.payment === 'seconds') {
      //     // 支払月1回目
      //     const once = moment(this.form.bonus_once_month).date(hikiotoshi_day).startOf('day')
      //     // 申込月
      //     const appMonth = this.getAppDate.clone().format('M');
      //     // ボーナス月
      //     const bonus = start.clone().month(once-1);

      //     if(appMonth == once && this.getAppDate.isBefore(bonus)) {
      //         this.form.payment_period_start = helper.helperConverDateJST(helper.helperGetBusinessDay(bonus));
      //     } else {
      //         this.form.payment_period_start = helper.helperConverDateJST(helper.helperGetBusinessDay(helper.helperGetbonusMonth(start,once)));
      //     }

      // } else {
      //     // ボーナス一括とボーナス二回以外
      // }
      // this.form.payment_period_start = helper.helperConverDateJST(helper.helperGetBusinessDay(start));
      this.form.payment_period_start = helper.helperGetBusinessDay(start).format('YYYY-MM-DD')
      this.splitPaymentPeriodStartYM()
      if (this.form.payment_period_start) this.updatePaymentPeriodEnd()
    },

    // 支払期間 終了更新
    updatePaymentPeriodEnd() {
      if (this.form.payment && this.form.payment_period_start) {
        // 基準日
        let standard = moment(this.form.payment_period_start).clone().startOf('day')
        // 引き落とし日
        const hikiotoshi_day = 27
        switch (this.form.payment) {
          case 'seconds':
            // 支払月2回目
            const seconds = moment(this.form.bonus_twice_month).format('M')
            if (!seconds) return

            // 基準日の年の支払月2回目を定義
            const secondsDate = standard
              .clone()
              .date(hikiotoshi_day)
              .month(seconds - 1)

            // 開始
            if (standard.isSameOrAfter(secondsDate)) {
              standard.date(hikiotoshi_day)
              // this.form.payment_period_end = helper.helperConverDateJST(helper.helperGetBusinessDay(helper.helperGetbonusMonth(standard,seconds)));
              this.form.payment_period_end = helper
                .helperGetBusinessDay(helper.helperGetbonusMonth(standard, seconds))
                .format('YYYY-MM-DD')
            } else {
              // this.form.payment_period_end = helper.helperConverDateJST(helper.helperGetBusinessDay(secondsDate));
              this.form.payment_period_end = helper.helperGetBusinessDay(secondsDate).format('YYYY-MM-DD')
            }
            break
          case 'split':
          case 'split_bonus':
            const count = Number(this.form.split_number) - 1
            if (count <= 0) return
            standard.date(hikiotoshi_day).add(count, 'M')
            // this.form.payment_period_end = helper.helperConverDateJST(helper.helperGetBusinessDay(standard));
            this.form.payment_period_end = helper.helperGetBusinessDay(standard).format('YYYY-MM-DD')
            break
          default:
            // this.form.payment_period_end = helper.helperConverDateJST(helper.helperGetBusinessDay(standard));
            this.form.payment_period_end = helper.helperGetBusinessDay(standard).format('YYYY-MM-DD')
            break
        }
      }
      this.simlation()
    },

    // お支払いの金額の計算処理
    simlation() {
      // アドオン取得
      const addon = this.getAddon
      if (!addon) return

      // 残金が無いとき処理をさせない
      if (this.form.remaining_money == null || this.form.remaining_money === '') return

      // 残金
      let total = Number(String(this.form.remaining_money).replace(/,/g, ''))

      let sim

      // 分割回数
      const count = Number(this.form.split_number)

      switch (this.form.payment) {
        case 'split':
          if (!count) return
          sim = splitPay(total, count, Number(addon.split_addon))
          this.form.payment_amount_once = sim.paymentAmountOnce
          this.form.payment_amount_second = sim.paymentAmountSecond
          this.form.split_fee = sim.fee
          this.form.split_total_payment = sim.total
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          break
        case 'split_bonus':
          if (
            !count ||
            !this.form.bonus_combined_addition_amount ||
            (!this.form.bonus_combined_month1 && !this.form.bonus_combined_month2)
          )
            return

          // 分割回数の回数分指定したボーナス月がどれだけあるか調べる処理
          const addition_amount = helper.helperNoneComma(this.form.bonus_combined_addition_amount)
          const month1 = this.form.bonus_combined_month1
          const month2 = this.form.bonus_combined_month2
          const payment_period_start = this.form.payment_period_start

          sim = splitBonusPay(
            total,
            count,
            addition_amount,
            month1,
            month2,
            payment_period_start,
            Number(addon.split_bonus_addon)
          )
          this.form.payment_amount_once = sim.paymentAmountOnce
          this.form.payment_amount_second = sim.paymentAmountSecond
          this.form.bonus_combined_number = sim.bonusCombinedNumber
          this.form.split_fee = sim.fee
          this.form.split_total_payment = sim.total
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          document.getElementById('bonus_combined_payment').value = addition_amount * sim.bonusCombinedNumber
          this.ignitionEvent('blur', 'bonus_combined_payment')
          break
        case 'once':
          sim = oncePay(total, Number(addon.once_addon), false)
          this.form.payment_amount_once = sim.paymentAmountOnce
          this.form.split_total_payment = sim.total
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          this.form.split_fee = sim.fee
          break
        case 'seconds':
          if (this.form.bonus_twice_month) {
            sim = secondsPay(total, Number(addon.seconds_addon), false)

            /**
             * 金額修正フラグがONの場合は変更しても再計算方法を変更
             */
            if (this.fixSecondPayment === true) {
              this.form.payment_amount_second = sim.total - helper.helperNoneComma(this.form.payment_amount_once)
            } else {
              this.form.payment_amount_once = sim.paymentAmountOnce
              this.form.payment_amount_second = sim.paymentAmountSecond
            }
            this.form.split_total_payment = sim.total
            this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
            this.form.split_fee = sim.fee
          }
          break
        case 'monthly':
          sim = monthlyPay(total, Number(addon.once_addon), false)
          this.form.payment_amount_once = sim.paymentAmountOnce
          this.form.split_total_payment = sim.total
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          break
        default:
          this.form.payment_amount_once = total.toLocaleString()
          this.form.split_total_payment = total.toLocaleString()
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          break
      }
    },
    // 申込日
    onChangeApplicationDate() {
      const selectedYear = this.userForm.application_date_year
      const selectedMonth = this.userForm.application_date_month
      const selectedDay = this.userForm.application_date_day
      const selectedLastDay = moment()
      selectedLastDay.year(selectedYear)
      selectedLastDay.month(selectedMonth - 1)
      selectedLastDay.endOf('month')
      const selectedMonthLastDate = selectedLastDay.date()

      if (selectedMonthLastDate < selectedDay) {
        this.userForm.application_date_day = null
      }

      this.applicationDays = [...Array(selectedMonthLastDate).keys()].map((i) => {
        const tmp = i + 1
        return {
          value: `${tmp}`,
          label: `${tmp}日`
        }
      })
    },

    ...mapActions({
      setForm: 'productInput/setForm',
      setUserForm: 'userInput/setForm',
      // php側のバリデーションエラー更新
      updateValidationsProductInput: 'productInput/updateValidations'
    })
  }
}
</script>

<style lang="scss">
@import '../../../../sass/_variables.scss';
#product_input {
  .product_titles {
    overflow: hidden;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    p {
      float: left;
      margin-bottom: 0;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #666;
    }

    p.product_name {
      width: 55%;
    }
    p.product_amount {
      width: 15%;
    }
    p.product_price {
      width: 35%;
    }
    p.product_delete {
      width: 10%;
    }
  }
  .product_list {
    margin-bottom: 0;
    list-style: none;
    padding-left: 0;
    margin-bottom: 10px;
    li {
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      .error_message {
        padding: 5px;
        border: 1px solid red;
        margin-top: 8px;
        border-radius: 4px;
      }
    }

    .product_box {
      overflow: hidden;

      .product_name,
      .product_amount,
      .product_price,
      .product_delete {
        float: left;
      }

      .product_name {
        width: 55%;
        padding-right: 10px;
        .el-select {
          width: 100%;
        }
      }

      .product_amount {
        width: 15%;
        padding-right: 10px;
        .el-select {
          width: 100%;
        }
      }

      .product_price {
        width: 35%;
        padding-right: 10px;
        .el-input {
          width: 100%;
        }
      }

      .product_delete {
        width: 10%;
        text-align: center;
      }
    }
    & + button {
      margin-bottom: 10px;
    }
  }

  .payment_form {
    // margin-top: 10px;
  }

  .payment_style_title {
    font-size: 12px;
    font-weight: bold;
    color: $--color-primary;
    text-align: center;
  }

  .table_block {
    .price_input {
      &__left {
        input {
          text-align: left;
        }
      }
    }
    .select {
      &--w120 {
        width: 120px;
      }
      &--w90 {
        width: 90px;
      }
    }
  }
}
</style>
